import React from 'react'
import PropTypes from 'prop-types'
import Dialog from '@mui/material/Dialog'
import Typography from '@mui/material/Typography'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import HHDialogTitle from 'components/common/HHDialogTitle'
import HHDialogActions from 'components/common/HHDialogActions'
import CancelButton from 'components/buttons/CancelButton'
import T from 'T'
import SaveButton from 'components/buttons/SaveButton'

const RevertInvoiceToDraftConfirmation = ({ isOpen = false, isLoading = false, onConfirm, onClose }) => {
  return (
    <Dialog open={isOpen}>
      <HHDialogTitle title={T.CHANGE_BACK_TO_DRAFT} onClose={onClose} />
      <DialogContent>
        <DialogContentText>
          <Typography variant="h5" color="textPrimary" fontWeight={400}>
            This invoice has already been sent to the customer. Do you want to proceed?
          </Typography>
        </DialogContentText>
      </DialogContent>
      <HHDialogActions>
        <CancelButton onClick={onClose} />
        <SaveButton loading={isLoading} color="warning" label={T.CONFIRM} onClick={onConfirm} />
      </HHDialogActions>
    </Dialog>
  )
}

RevertInvoiceToDraftConfirmation.propTypes = {
  isOpen: PropTypes.bool,
  isLoading: PropTypes.bool,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default RevertInvoiceToDraftConfirmation
